export default __webpack_public_path__ + "static/media/sr-90.3ddd703c.mp3";